import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { PropertyType } from "@/components/properties/property-type-select";

interface Property {
  id: string;
  address: string;
  propertyType: PropertyType;
  numberOfUnits: number;
  acquisitionDate: string;
  acquisitionPrice: string;
  approximateLoan?: string;
  currentMarketValue?: string;
  monthlyRent?: string;
  // Cash on Cash Return fields
  downPayment?: string;
  closingCosts?: string;
  initialRepairs?: string;
  otherInitialCosts?: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

interface PropertiesState {
  items: Property[];
  loading: boolean;
  error: string | null;
}

const initialState: PropertiesState = {
  items: [],
  loading: false,
  error: null,
};

const propertiesSlice = createSlice({
  name: "properties",
  initialState,
  reducers: {
    setProperties: (state, action: PayloadAction<Property[]>) => {
      state.items = action.payload;
      state.loading = false;
      state.error = null;
    },
    addProperty: (state, action: PayloadAction<Property>) => {
      state.items.push(action.payload);
    },
    updateProperty: (state, action: PayloadAction<Property>) => {
      const index = state.items.findIndex((p) => p.id === action.payload.id);
      if (index !== -1) {
        state.items[index] = action.payload;
      }
    },
    deleteProperty: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter((p) => p.id !== action.payload);
    },
    setPropertiesLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    },
    setPropertiesError: (state, action: PayloadAction<string>) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export const {
  setProperties,
  addProperty,
  updateProperty,
  deleteProperty,
  setPropertiesLoading,
  setPropertiesError,
} = propertiesSlice.actions;

export default propertiesSlice.reducer;
